import { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "../context/createClient.js";


// Create context
export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState();
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

// Load session on app start
  useEffect(() => {
    const getSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      
      console.log("initial session", session)
      console.log("initial user", user)

      setSession(session);
      setUser(session?.user ?? null);
      setLoading(false);
    }

    getSession()

    // Listen for auth changes
    const {
        data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
        setSession(session);
        setUser(session?.user ?? null);
        })
    }, [])

const signUp = async (email, password) => {
   return await supabase.auth.signUp({
      email,
      password,
    }) 
}

const signIn = async (email, password) => {
    return await supabase.auth.signInWithPassword({
      email,
      password,
    })
  }

  // Sign out
  const signOut = async () => {
    return await supabase.auth.signOut()
  }


    const value = {
    session,
    user,
    loading,
    signUp,
    signIn,
    signOut,
  }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}